import { Format } from "./format";

export const AgFormat = {
  AgGridDateFilter,
  AgGridFormatDate,
  AgGridFormatMoney,
  AgGridFormatPercentage,
  AgGridFormatPercentageWithSeparator,
  AgGridPercentage,
  AgGridPercentageBudget,
  AgGridRemoveNull,
  AgNumaricStyle,
  AgNumberComparator,
  AgNumberComparatorNumeric,
  AgRowGroupHeaderStyle,
  AgVarianceCellStyle,
  AgVariancePercentage,
  AgVariancePercentageForBudget,
  AgVariancePercentageForRgcp,
  AgVariancePercentageGroupCell,
  AgVarianceStyle,
  AgVarianceStyleNumeric,
  AgVarianceTotalPercentage,
  BudgetCalcy,
  BudgetProrataCalcy,
  DealListAgGridFormatMoney,
  ShowCellTooltip,
  columnTotal,
  columnTotalBudget,
  percentageTotal,
  percentageTotalForBudget,
};

function columnTotalBudget(values: any) {
  return values[0];
}

function BudgetCalcy(params: any) {
  let converted = params.node.group
    ? params.node.aggData.sc_budget_team
    : params.data[params.colDef.field];
  if (isNaN(converted)) {
    return "--";
  }
  converted = converted !== 0 ? converted / 1000 : 0;
  return Number(converted.toFixed()).toLocaleString("en");
}

function BudgetProrataCalcy(params: any) {
  const value =
    params.node.group === true
      ? Format.CalculateBudgetPercentageForSalesList(
          Number(params.node.aggData.sc_ytd.replace(",", "")),
          params.node.aggData.sc_budget_team_prorata,
          0
        )
      : params.data[params.colDef.field];
  if (isNaN(value)) {
    return "--";
  }
  return value > 0 ? "+" + value + " %" : value + " %";
}

function CheckAndReplacePercentage(
  value: any,
  checkValue: any,
  assignValue: any,
  replaceValue: any
): any {
  return value === checkValue ? assignValue : replaceValue.replace(/[,%]/g, "");
}

export function AgNumberComparator(n1: any, n2: any) {
  const a = CheckAndReplacePercentage(n1, "--", NaN, n1);
  const b = CheckAndReplacePercentage(n2, "--", NaN, n2);

  if (!isFinite(a) && !isFinite(b)) {
    return 0;
  }
  if (!isFinite(a)) {
    return -1;
  }
  if (!isFinite(b)) {
    return 1;
  }
  return a - b;
}

export function AgNumberComparatorNumeric(n1: any, n2: any) {
  let a: any;
  let b: any;
  if (typeof n1 === "string" && typeof n2 === "string") {
    a = CheckAndReplacePercentage(n1, "--", NaN, n1);
    b = CheckAndReplacePercentage(n2, "--", NaN, n2);
  }
  if (typeof n1 === "number" && typeof n2 === "number") {
    a = CheckAndReplacePercentage(n1, 0, NaN, n1.toFixed());
    b = CheckAndReplacePercentage(n2, 0, NaN, n2.toFixed());
  }
  if (!isFinite(a) && !isFinite(b)) {
    return 0;
  }
  if (!isFinite(a)) {
    return -1;
  }
  if (!isFinite(b)) {
    return 1;
  }
  return a - b;
}

function ShowCellTooltip(params: any) {
  if (params.value === undefined || params.value === null) {
    return "";
  }
  return params.value;
}

function AgGridFormatMoney(params: any) {
  const converted = params.data[params.colDef.field] / 1000;
  if (isNaN(converted)) {
    return "--";
  }
  return Number(converted.toFixed()).toLocaleString("en");
}

function DealListAgGridFormatMoney(params: any) {
  const converted = params.data[params.colDef.field] / 1000;
  if (isNaN(converted)) {
    return "--";
  }
  return Number(converted.toFixed(1)).toLocaleString("en");
}

function AgGridRemoveNull(params: any) {
  const fieldValue = params.data[params.colDef.field];
  if (fieldValue === "Null") {
    return "--";
  }
  return fieldValue;
}

function AgGridFormatDate(params: any) {
  if (params === "Null") {
    return "--";
  }
  const sptdate = String(params).split("-");
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const myMonth: any = sptdate[1];
  return sptdate[2] + " " + months[myMonth - 1] + " " + sptdate[0];
}

function AgGridPercentage(params: any) {
  const value = params.data[params.colDef.field];
  if (isNaN(value)) {
    return "--";
  }
  return (value * 100).toFixed(0);
}

function AgGridFormatPercentage(params: any) {
  const value = params.data[params.colDef.field];
  if (isNaN(value)) {
    return "--";
  }
  return value.toFixed(0) + "%";
}

function AgGridFormatPercentageWithSeparator(params: any) {
  const value = params.data[params.colDef.field];
  if (isNaN(value)) {
    return "--";
  }
  return Number(value.toFixed(0)).toLocaleString("en") + "%";
}

function AgGridPercentageBudget(params: any) {
  const value = params.data[params.colDef.field];
  if (isNaN(value)) {
    return "--";
  }
  return value.toFixed(0);
}

function AgVariancePercentage(params: any) {
  const value = params.data[params.colDef.field];
  if (isNaN(value)) {
    return "--";
  }
  return value > 0
    ? "+" + (value * 100).toFixed(0) + " %"
    : (value * 100).toFixed(0) + " %";
}

function AgVariancePercentageForRgcp(params: any) {
  const value = params.data[params.colDef.field];
  if (isNaN(value) || value.toString() === "Infinity") {
    return "--";
  }
  return (value * 100).toFixed(0) + " %";
}

export function AgVariancePercentageGroupCell(params: any) {
  if (params.node.group === true) {
    const ytd = Number(params.node.aggData.sc_ytd.replace(",", ""));
    const ytd1 = Number(params.node.aggData.sc_ytd_1.replace(",", ""));
    const value = (ytd - ytd1) / Math.abs(ytd1);
    if (isNaN(value)) {
      return "0 %";
    }
    return value > 0
      ? "+" + (value * 100).toFixed(0) + " %"
      : (value * 100).toFixed(0) + " %";
  } else {
    const value = params.data[params.colDef.field];
    if (isNaN(value)) {
      return "--";
    }
    return value > 0
      ? "+" + (value * 100).toFixed(0) + " %"
      : (value * 100).toFixed(0) + " %";
  }
}

function AgVariancePercentageForBudget(params: any) {
  const value = params.data[params.colDef.field];
  if (isNaN(value)) {
    return "--";
  }
  return value > 0 ? "+" + value + " %" : value + " %";
}

function AgVarianceStyle(params: any) {
  if (params.node.group === true) {
    if (params.value === "--") {
      return {
        backgroundColor: "lightblue",
        paddingRight: "25px",
        textAlign: "right",
      };
    }
    const value1 = params.value.replace(/[,%]/g, "");
    if (value1 > 0) {
      return {
        backgroundColor: "lightblue",
        color: "#088A08",
        paddingRight: "25px",
        textAlign: "right",
      };
    }
    return {
      backgroundColor: "lightblue",
      color: "#FF0000",
      paddingRight: "25px",
      textAlign: "right",
    };
  }
  if (params.value === "--") {
    return {
      paddingRight: "25px",
      textAlign: "right",
    };
  }
  const value = params.value.replace(/[,%]/g, "");
  if (value > 0) {
    return {
      color: "#088A08",
      paddingRight: "25px",
      textAlign: "right",
    };
  }
  return {
    color: "#FF0000",
    paddingRight: "25px",
    textAlign: "right",
  };
}

// tslint:disable-next-line:cognitive-complexity
function AgVarianceStyleNumeric(params: any) {
  if (params.node.group === true) {
    if (
      (typeof params.value === "string" && params.value === "--") ||
      (typeof params.value === "number" && params.value.isNaN)
    ) {
      return {
        backgroundColor: "lightblue",
        paddingRight: "25px",
        textAlign: "right",
      };
    }
    const value1 =
      typeof params.value === "string"
        ? params.value.replace(/[,%]/g, "")
        : params.value.toFixed().replace(/[,%]/g, "");
    if (value1 > 0) {
      return {
        // backgroundColor: "lightblue",
        color: "#088A08",
        paddingRight: "25px",
        textAlign: "right",
      };
    }
    return {
      // backgroundColor: "lightblue",
      color: "#FF0000",
      paddingRight: "25px",
      textAlign: "right",
    };
  }
  if (
    (typeof params.value === "string" && params.value === "--") ||
    (typeof params.value === "number" && params.value.isNaN)
  ) {
    return {
      paddingRight: "25px",
      textAlign: "right",
    };
  }
  const value =
    typeof params.value === "string"
      ? params.value.replace(/[,%]/g, "")
      : params.value.toFixed().replace(/[,%]/g, "");
  if (value > 0) {
    return {
      color: "#088A08",
      paddingRight: "25px",
      textAlign: "right",
    };
  }
  return {
    color: "#FF0000",
    paddingRight: "25px",
    textAlign: "right",
  };
}

function AgNumaricStyle(params: any) {
  if (params.node.group === true) {
    return {
      backgroundColor: "lightblue",
      paddingRight: "25px",
      textAlign: "right",
    };
  }
  return {
    paddingRight: "25px",
    textAlign: "right",
  };
}

function AgGridDateFilter(filterLocalDateAtMidnight: any, cellValue: any) {
  const cellDate = Format.ParseDateWithNamedMonths(cellValue);

  if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
    return 0;
  }

  if (cellDate < filterLocalDateAtMidnight) {
    return -1;
  }

  if (cellDate > filterLocalDateAtMidnight) {
    return 1;
  }
}

function columnTotal(values: any) {
  let sum = 0;
  values.forEach((value: any) => {
    const item = value.replace(/[,%]/g, "");
    if (!isNaN(item)) {
      sum += Number(item);
    }
  });
  return Number(sum.toFixed()).toLocaleString("en");
}

function AgVarianceTotalPercentage(values: any) {
  let sum = 0;
  let i = 0;
  values.forEach((value: any) => {
    const item = value.replace(/[,%]/g, "");
    if (!isNaN(item)) {
      sum += Number(item);
      i++;
    }
  });
  if (i > 0) {
    sum = sum / i;
  }
  return Number(sum.toFixed()).toLocaleString("en") + " %";
}

function percentageTotal(values: any) {
  let sum = 0;
  values.forEach((value: any) => {
    if (!isNaN(value)) {
      const item =
        value.toString().indexOf("%") > -1 ? value.replace("%", "") : value;
      sum += Number(item);
    }
  });
  return sum.toString();
}

function percentageTotalForBudget(values: any) {
  let sum = 0;
  values.forEach((value: any) => {
    const item =
      value.toString().indexOf("%") > -1 ? value.replace("%", "") : value;
    if (!isNaN(item)) {
      sum += Number(item);
    }
  });
  return sum > 0 ? "+" + sum.toString() + "%" : sum.toString() + "%";
}

function AgRowGroupHeaderStyle(params: any) {
  if (params.node.group === true) {
    return {
      backgroundColor: "lightblue",
    };
  }
  return {};
}

function AgVarianceCellStyle(params: any) {
  if (!params.value || params.value === "--") {
    return {
      backgroundColor: "#9bd6ab",
      color: "#088A08",
      paddingRight: "25px",
      textAlign: "right",
    };
  }
  const value = params.value.toString().replace("%", "");
  if (value > 0) {
    return {
      backgroundColor: "#9bd6ab",
      color: "#088A08",
      paddingRight: "25px",
      textAlign: "right",
    };
  }
  return {
    backgroundColor: "#f9a1a3",
    color: "#FF0000",
    paddingRight: "25px",
    textAlign: "right",
  };
}
